import LocationsContainer from './LocationsContainer';

export default LocationsContainer;
